/**
 * Publish product_added_to_cart for Shopify Web Pixels (Meta/Facebook channel).
 * Custom /cart/add.js ATC paths bypass Dawn's product-form, so Meta never sees AddToCart
 * unless we publish this standard customer event.
 */
(function () {
  function currencyCode() {
    try {
      if (window.Shopify && Shopify.currency && Shopify.currency.active) return Shopify.currency.active;
    } catch (e) {}
    return 'USD';
  }

  function moneyAmount(item) {
    // Ajax Cart API returns cents
    var cents = item.final_line_price != null ? item.final_line_price
      : item.final_price != null ? item.final_price
      : item.price != null ? item.price
      : 0;
    var qty = Number(item.quantity || 1) || 1;
    // Prefer unit price for merchandise.price; total for cartLine.cost
    var unit = item.final_price != null ? item.final_price : item.price;
    return {
      unit: (Number(unit || 0) / 100).toFixed(2),
      total: (Number(cents || 0) / 100).toFixed(2),
      qty: qty
    };
  }

  function publishOne(item) {
    if (!item || item.status || item.message) return;
    var money = moneyAmount(item);
    var currency = currencyCode();
    var variantId = String(item.variant_id || item.id || '');
    var productId = String(item.product_id || '');
    var payload = {
      cartLine: {
        cost: {
          totalAmount: { amount: money.total, currencyCode: currency }
        },
        merchandise: {
          id: variantId,
          title: item.variant_title || item.title || '',
          price: { amount: money.unit, currencyCode: currency },
          product: {
            id: productId,
            title: item.product_title || item.title || '',
            type: item.product_type || '',
            vendor: item.vendor || '',
            untranslatedTitle: item.product_title || item.title || ''
          },
          untranslatedTitle: item.variant_title || item.title || '',
          sku: item.sku || ''
        },
        quantity: money.qty
      }
    };

    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('product_added_to_cart', payload);
      }
    } catch (e) {}

    // Direct browser pixel if present outside web-pixel sandbox
    try {
      if (false) {
        window.fbq('track', 'AddToCart', {
          content_ids: [variantId],
          content_type: 'product',
          content_name: item.product_title || item.title || '',
          content_category: item.product_type || '',
          value: Number(money.total),
          currency: currency,
          contents: [{ id: variantId, quantity: money.qty }],
          num_items: money.qty
        });
      }
    } catch (e) {}
  }

  /**
   * @param {object|object[]} data - /cart/add.js response (single line or {items:[...]})
   */
  window.enigPublishAddToCart = function (data) {
    try {
      if (!data) return;
      if (Array.isArray(data.items)) {
        data.items.forEach(publishOne);
        return;
      }
      if (Array.isArray(data)) {
        data.forEach(publishOne);
        return;
      }
      publishOne(data);
    } catch (e) {}
  };
})();
